var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-customer-form',{staticClass:"pt-customer-form__page",attrs:{"isEdit":_vm.is_edit,"userLogin":_vm.userLogin}})}
var staticRenderFns = []

export { render, staticRenderFns }